import { gsap } from 'gsap';
import { init, enter } from '../animations';

let svgFillAnimation;
let svgHandAnimation;

export function interactionEnter(el) {
  const content = el.querySelector('.ui-tutorial__content');
  const svg = el.querySelector('svg');
  const svgFill = el.querySelector('.svg__fill');
  const svgHand = el.querySelector('.svg__hand');
  const tl = gsap.timeline();

  gsap.set(svgFill, { drawSVG: '0% 0%' });
  gsap.set(svgHand, { rotation: 45, transformOrigin: 'center bottom' });

  tl.addLabel('start')
    .from(content, {
      autoAlpha: 0,
      y: 20,
      ease: 'power3.easeInOut',
      duration: 0.8,
      clearProps: 'all',
    }, 'start')
    .from(svg, {
      autoAlpha: 0,
      y: 20,
      ease: 'power3.easeInOut',
      duration: 0.8,
      clearProps: 'all',
      onComplete: () => {
        svgHandAnimation = gsap.to(svgHand, {
          rotation: -45,
          duration: 1,
          yoyo: true,
          repeat: -1,
          ease: 'power1.inOut',
        });
        svgFillAnimation = gsap.to(svgFill, {
          drawSVG: '100% 50%',
          duration: 1,
          yoyo: true,
          repeat: -1,
          ease: 'power1.inOut',
        });
      },
    }, 'start+=0.4');

  return tl;
}

export function leavesEnter(el) {
  const content = [...el.querySelectorAll('.ui-tutorial__content')];
  const leaves = [...el.querySelectorAll('.ui-tutorial__image')];
  const tl = gsap.timeline();

  tl.addLabel('start')
    .from(content, {
      autoAlpha: 0,
      y: 20,
      duration: 0.8,
      stagger: 0.8,
      ease: 'power3.easeInOut',
      clearProps: 'all',
    }, 'start')
    .from(leaves, {
      scale: 0,
      duration: 0.8,
      stagger: 0.8,
      ease: 'flap',
      clearProps: 'all',
    }, 'start+=0.2');

  return tl;
}

export function fruitsEnter(el) {
  const content = el.querySelectorAll('.ui-tutorial__content');
  const separator = el.querySelectorAll('.ui-tutorial__separator');
  const images = [...el.querySelectorAll('.ui-tutorial__image')];
  const tl = gsap.timeline();

  tl.addLabel('start')
    .from(content, {
      autoAlpha: 0,
      y: 20,
      duration: 0.8,
      ease: 'power3.easeInOut',
      clearProps: 'all',
    }, 'start')
    .from(separator, {
      autoAlpha: 0,
      duration: 0.6,
      ease: 'power3.easeInOut',
      clearProps: 'all',
    }, 'start+=0.6')
    .from(images, {
      scale: 0,
      duration: 0.8,
      stagger: 0.5,
      ease: 'flap',
      clearProps: 'all',
    }, 'start+=0.3');

  return tl;
}

export function tutorialPhaseLeave(el) {
  const tl = gsap.timeline({
    onComplete: () => {
      if (svgFillAnimation) {
        svgFillAnimation.kill();
        svgHandAnimation.kill();
        svgFillAnimation = null;
        svgHandAnimation = null;
      }
    },
  });

  tl.addLabel('start')
    .to(el, {
      opacity: 0,
      y: -20,
      duration: 0.5,
      ease: 'power3.easeOut',
    }, 'start');

  return tl;
}

export function tutorialEnter(el) {
  const bg = el.querySelector('.ui-tutorial__bg');
  const tl = gsap.timeline();

  init.get('fade')(bg);

  tl.addLabel('start')
    .add(enter.get('fade')(bg, 0, 0.5), 'start');

  return tl;
}

export function tutorialLeave(el) {
  const content = el.querySelector('.ui-tutorial__phase');
  const bg = el.querySelector('.ui-tutorial__bg');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(content, {
      y: -20,
      opacity: 0,
      duration: 0.5,
      ease: 'power3.easeOut',
    }, 'start')
    .to(bg, { opacity: 0, duration: 0.5, ease: 'power3.easeOut' }, 'start+=0.1');

  return tl;
}
